import { useEffect, useState } from "react";
import { navLinks } from "../../../mocks/starTracker";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center justify-between px-4 md:px-6 lg:px-10">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2.5 whitespace-nowrap"
          aria-label="回声观察社 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
            <i className="ri-focus-3-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
            回声观察社
          </span>
          <span className="ml-1 hidden rounded-full border border-primary-200 bg-primary-50 px-2 py-0.5 text-[11px] font-medium text-primary-700 sm:inline-block whitespace-nowrap">
            事件追踪观察
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(l.id);
              }}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950 whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#types"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("types");
            }}
            className="hidden whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700 sm:inline-flex"
          >
            开始追踪
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-2 lg:hidden"
          aria-label="移动端导航"
        >
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(l.id);
              }}
              className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
            >
              {l.label}
              <i className="ri-arrow-right-s-line text-secondary-400"></i>
            </a>
          ))}
          <a
            href="#types"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("types");
            }}
            className="mt-3 flex items-center justify-center whitespace-nowrap rounded-md bg-primary-600 px-4 py-3 text-sm font-semibold text-background-50"
          >
            开始追踪
          </a>
        </nav>
      )}
    </header>
  );
}